<div class="access-denied-container">
  <img
    src="../../../assets/images/error/access-denied.png"
    alt="Access Denied"
  />
  <h1>Access Denied</h1>
  <h4>You do not have permission to view this page.</h4>
  <h4>Please check your credentials and try again.</h4>
</div>
